module.exports = __webpack_public_path__ + "img/Group 27487.9eace5f9.png";